import Head from 'next/head';

import {
  ContentWrapper,
  PageWrapper,
} from './Layout.styles';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => (
  <PageWrapper>
    <Head>
      <title key="title">Muster</title>
    </Head>
    <ContentWrapper>
      {children}
    </ContentWrapper>
  </PageWrapper>
);
